
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";


export class DebouncedTextField extends Component {

  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    delay: PropTypes.number,
    showResetButton: PropTypes.bool
  };

  static defaultProps = {
    delay: 300,
    showResetButton: false
  };

  constructor(props) {
    super(props);

    this.state = {
      value: this.prepareValue(this.props.value),
      ignoreKeys: ['ArrowUp', 'ArrowDown'],
      focused: false
    };

    this.debouncedValue = debounce(
      () => this.handleDebounced(),
      this.props.delay
    );

    this.ref = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  // eslint-disable-next-line
  componentWillReceiveProps(nextProps) {
    if (this.state.focused === false && nextProps.value !== this.state.value) {
      this.setState({
        value: this.prepareValue(nextProps.value)
      });
    }
  }

  handleDebounced = () => {
    const { onChange } = this.props;
    onChange(this.state.value);
  };

  prepareValue = (value) => {
    if (typeof value === "number") {
      value = value.toString();
    }
    else if (typeof value !== 'string') {
      value = '';
    }
    return value;
  };

  handleChange(event) {
    let value = event.target.value;
    this.setState({
      value: value
    });
    this.debouncedValue();
  }

  setValue = (value) => {
    this.setState({
      value: value
    });
    this.debouncedValue();
  }

  handleKeyDown(e) {
    if (this.state.ignoreKeys.includes(e.key)) {
      e.preventDefault();
    }
  }

  handleReset() {
    const { onChange } = this.props;
    this.setState({value: ''});
    onChange('');
  }

  handleFocus = () => {
    this.setState({focused: true})
  };

  handleBlur = () => {
    this.setState({focused: false})
  };

  render() {
    const currentValue = this.state.value;
    const { loading, showResetButton, onChange, value, ...otherProps } = this.props;
    return (
      <TextField
        value={currentValue}
        onChange={this.handleChange}
        onKeyDown={this.handleKeyDown}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        InputProps={{
          endAdornment: (
            (currentValue && (
              <InputAdornment position="end">
                <IconButton size={'small'} onClick={() => this.setValue('')}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ))
          )
        }}
        {...otherProps}
      />
    )
  }
}

